<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    mode?: string | null
    clickable?: boolean
    pointerPosition?: string | null
    pointerDirection?: string
  }>(),
  {
    mode: null,
    clickable: false,
    pointerPosition: null,
    pointerDirection: 'vertical',
  },
)

defineEmits<{
  (e: 'click'): void
}>()

const classes = computed(() => {
  const classes: string[] = []
  if (props.mode) classes.push(`Message--${props.mode}`)
  if (props.clickable) classes.push(`Message--clickable`)
  return classes
})

const pointerClasses = computed(() => {
  const classes: string[] = []
  if (props.pointerPosition && props.pointerDirection) {
    classes.push(
      `Message__Pointer--${props.pointerPosition}-${props.pointerDirection}`,
    )
  }
  return classes
})
</script>

<template>
  <div class="Message" :class="classes" @click="$emit('click')">
    <span
      v-if="pointerPosition"
      class="Message__Pointer"
      :class="pointerClasses"
    ></span>
    <div v-if="$slots.icon" class="Message__Icon">
      <slot name="icon" />
    </div>
    <div class="Message__Content">
      <slot name="content" />
    </div>
  </div>
</template>
